var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-networks-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var brief = ref.brief;
var contact = ref.contact;
var networkId = ref.networkId;
var instagramGraphRequired = ref.instagramGraphRequired;
return [_c('activation-brief-connect-network-view',{attrs:{"brief":brief,"contact":contact,"network-id":networkId,"instagram-graph-required":instagramGraphRequired}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }